import { Flex, Typography, InputNumber, Select, Image } from "antd"
import ArrowDownIcon from "../../assets/icons/arrow-down-icon.svg"

const { Text } = Typography

const DealDetail = ({ label, value, isInput, isSelect, name, rules, options, onchange, height, status, className, style, ...rest }) => {
    return (
        <Flex justify="space-between" align="center" style={{ height: height }}>
            <Text style={{ fontWeight: 600 }}>{label}:</Text>
            {isInput ? (
                <InputNumber
                    name={name}
                    type="text"
                    placeholder={`Enter ${label}`}
                    rules={rules}
                    value={value}
                    status={status}
                    className={className}
                    onChange={onchange}
                    formatter={(value) =>
                        value
                            ? `${new Intl.NumberFormat('en-IN', {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                            }).format(Number(value))}`
                            : ''
                    }
                    parser={(value) => value?.replace(/[^\d.]/g, '')}
                    style={{ width: 200, ...style }}
                    controls={false}
                    {...rest}
                />
            ) : isSelect ? (
                <Select
                    name={name}
                    showSearch
                    placeholder={`Select ${label}`}
                    options={options}
                    value={value}
                    status={status}
                    className={className}
                    onChange={onchange}
                    rules={rules}
                    style={{ width: 200, height: 46.6, ...style }}
                    suffixIcon={<Image src={ArrowDownIcon} alt='Arrow Down' preview={false} />}
                    {...rest}
                />
            ) : (
                <Text style={{ color: "#004A2A", fontWeight: 500 }}>{value}</Text>
            )}
        </Flex>
    )
}

export default DealDetail
